module.exports = __webpack_public_path__ + "assets/rm-logo-short-2.6c68b879.png";